import { inject } from '@angular/core';
import { Type } from '@angular/core';
import { LayoutService } from '../services/layout.service';

type ModuleRef<T> = Record<string, Type<T>>;

/**
 * Sempre carrega a versão clássica (ng-zorro), ignorando preferência de layout V2.
 */
export function loadClassicPage<TClassic>(
  classicImport: () => Promise<ModuleRef<TClassic>>,
  exportName: string,
): () => Promise<Type<TClassic>> {
  return async () => {
    const mod = await classicImport();
    return mod[exportName] as Type<TClassic>;
  };
}

/**
 * Carrega a versão clássica (ng-zorro) ou V2 (Tailwind/ui-kit) conforme preferência do usuário.
 */
export function loadLayoutPage<TClassic, TV2 = TClassic>(
  classicImport: () => Promise<ModuleRef<TClassic>>,
  exportName: string,
  v2Import: () => Promise<ModuleRef<TV2>>,
): () => Promise<Type<TClassic>> {
  return async () => {
    const layout = inject(LayoutService);
    const mod = layout.useModernLayout() ? await v2Import() : await classicImport();
    return mod[exportName] as Type<TClassic>;
  };
}
